/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-02 16:57:55
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-06 10:51:25
 */
const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'
// 政策汇编列表查询
export const listAssemblyData = params =>
  request(BASE_URL + '/policyAssembly/listAssemblyData', { params })
// 删除政策汇编
export const deleteAssembly = params =>
  request.post(BASE_URL + '/policyAssembly/deleteAssembly', params)
// 政策汇编详情
export const getAssemblyById = params =>
  request(BASE_URL + '/policyAssembly/getAssemblyById', { params })
// 新增或编辑政策汇编
export const updateOrInsertAssembly = params =>
  request.post(BASE_URL + '/policyAssembly/updateOrInsertAssembly', params)
// 文件上传
export const uploadFileByContentType2 =
  process.env.VUE_APP_BASE_API + BASE_URL + '/api/file/uploadFileByContentType2'
// 异步上传文件查询接口
export const getUploadProcess = params =>
  request(BASE_URL + '/api/file/getUploadProcess', { params })

// 置顶操作
export const updateTopOperate = data => request.post(BASE_URL + '/policyAssembly/updateTopeActivity', data)
